import { client } from './api-client';
const localStorageKey = 'access_token';

export const fetchSubscriptionsProducts = () => client.get(`products`);
export const fetchSubscriptionsProductsExternal = () =>
  client.get(`products`, {
    headers: { Accept: 'application/vnd.briz.external.v1+json' }
  });
export const fetchSubscriptionsProductsWithChannels = () => client.get(`tv/channels-grouped`);
export const restoreSubscriptionApi = (body) => client.post('subscribe', body);
export const promocodeApi = (body) =>
  client.post('promocode', body, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem(localStorageKey)}`
    }
  });
